import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocationsGroupsService } from 'app/main/locations-groups/services/locations-groups-resolver.service';

import { LocationGroupLegacyComponent } from './location-group.component';

@NgModule({
  entryComponents: [
    LocationGroupLegacyComponent
  ],
  declarations: [
    LocationGroupLegacyComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule
  ],
  providers: [
    LocationsGroupsService
  ],
  exports: [
    LocationGroupLegacyComponent
  ]
})
export class LocationGroupLegacyModule { }
